"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Biofuels = void 0;
var Tags_1 = require("../Tags");
var PreludeCard_1 = require("./PreludeCard");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Biofuels = (function (_super) {
    __extends(Biofuels, _super);
    function Biofuels() {
        return _super.call(this, {
            name: CardName_1.CardName.BIOFUELS,
            tags: [Tags_1.Tags.MICROBE],
            metadata: {
                cardNumber: 'P03',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.energy(1).plants(1); }).br;
                    b.plants(2);
                }),
                description: 'Increase your energy and plant production 1 step. Gain 2 plants.',
            },
        }) || this;
    }
    Biofuels.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.ENERGY, 1);
        player.addProduction(Resources_1.Resources.PLANTS, 1);
        player.plants += 2;
        return undefined;
    };
    return Biofuels;
}(PreludeCard_1.PreludeCard));
exports.Biofuels = Biofuels;
//# sourceMappingURL=Biofuels.js.map